module.exports = __webpack_public_path__ + "static/media/success.170bb0b4.svg";